import apiClient from '../apiClient';
import { GET_ACCOMODATION_LOCATION_URL } from '../apiUrl';

const getAccomodationLocationsApi = () => {
  return apiClient.get(GET_ACCOMODATION_LOCATION_URL);
};

export default getAccomodationLocationsApi;
